<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <!-- 外层循环盒子增加点击跳转 -->
        <div 
          class="case-section-content-list" 
          v-for="(cas,index) in caseList" 
          :key="index"
          @click="goDetail(cas)"
        >
          <img v-lazy="imgserver+cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="item-list-content">{{ getPureText(cas.Content, 80) }}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id }}"
                @click.stop
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: []
    };
  },
   methods: {
        // 新增跳转方法
      goDetail(cas){
        this.$router.push({ name: 'casedetails', params: { id: cas.Id } })
      },
      getPureText(html, len = 80) {
        if (!html) return ''
        // 移除所有HTML标签
        let plainText = html.replace(/<[^>]+>/g, '')
        plainText = plainText.replace(/&[a-z0-9]+;/gi, '')
        // 清除多余换行、空格
        plainText = plainText.replace(/\s+/g, '')
        if (plainText.length > len) {
          return plainText.slice(0, len) + '...'
        } else {
          return plainText
        }
      }
   },
  mounted() {
    window.console.log("case");
    this.$http.get("Case").then(response => {
        this.caseList = response.data.result;
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  }
};
</script>

 <style lang="scss" scoped>
 .case-section-content-list{
  cursor: pointer;
}
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>